<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box"></div>
            <div class="about-wrap">
                <div class=" about">
                    <div class="logo">
                        <div class="img" :style="{backgroundImage:'url('+util.autoImage(sponsor.logo)+')'}"></div>
                    </div>
                    <div class=" tit">{{sponsor.title}}</div>
                    <div class=" desc">{{sponsor.desc}}</div>
                    <div class="link" v-if="sponsor.link" @click="util.toLink(sponsor.link,'','_blank')"><span>查看更多</span></div>
                </div>
                <div class=" info">
                    <div class="info-tit">
                        <div class="center">
                            <div class="left item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)"><div class="middle">精彩视频</div></div>
                            <div class="left item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)"><div class="middle">资料下载</div></div>
                            <div class="left item" :class="[tab == 3 ? 'active' : '']" @click="setTab(3)" style="display: none;"><div class="middle">相关会议日程列表</div></div>
                        </div>
                    </div>
                    <div class="tab">
<!--                        <div class="video-box" :class="[tab == 1 ? 'active' : '']">-->
<!--                            <div class=" video" v-if="sponsor.video" :class="[!video_play_show ? 'full' : '']">-->
<!--                                <video :class="[!video_play_show ? 'full' : '']" :controls="!video_play_show ? true : false" x5-video-player-type="h5-page" :poster="util.autoImage(sponsor.video)+'?x-oss-process=video/snapshot,t_55000,f_jpg,m_fast'" id="s1_video" loop @click.prevent="stopVideo" >-->
<!--                                    <source :src="util.autoImage(sponsor.video)">-->
<!--                                </video>-->
<!--                                <div class="mark" v-if="video_play_show">-->
<!--                                    <div class="play" @click="playVideo"></div>-->
<!--                                </div>-->
<!--                                <div class="full-close" @click.prevent="stopVideo"></div>-->
<!--                            </div>-->
<!--                        </div>-->
						<div class="download-box" :class="[tab == 1 ? 'active' : '']">
							<div class="list">
								<div class="item" v-for="item in sponsor.video">
									<div class="left tit-box video">
										<div class="middle">
											<div class="element-more tit">{{item.title}}</div>
										</div>
									</div>
									<div class="left link video" @click="showVideo(item)"><a href="javascript:;">观看视频</a></div>
								</div>
							</div>
						</div>
                        <div class="download-box" :class="[tab == 2 ? 'active' : '']">
                            <div class="list">
                                <div class="item" v-for="item in sponsor.file">
                                    <div class="left tit-box" :class="[item.type == 1 ? 'word' : item.type == 2 ? 'pdf' : 'ppt']">
                                        <div class="middle">
                                            <div class="element-more tit">{{item.title}}</div>
                                        </div>
                                    </div>
                                    <div class="left size">{{item.size}}MB</div>
                                    <div class="left link" @click="showDownload(item)"><a href="javascript:;">下载</a></div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="plan-box" :class="[tab == 3 ? 'active' : '']" style="display: none;">
                            <div class="list">
                                <div class="item" v-for="item in sponsor.session" @click="toMudu(item)">
                                    <div class="left time">{{tool.date.formatDate('H:i',item.live_start)}}-{{tool.date.formatDate('H:i',item.live_end)}}</div>
                                    <div class="left tit-box">
                                        <div class="element tit">{{item.title}}</div>
                                        <div class="clear author"><span>{{item.speaker}}</span><span>{{item.speaker_job}}</span></div>
                                        <div class="clear author" v-if="item.speaker2"><span>{{item.speaker2}}</span><span>{{item.speaker2_job}}</span></div>
                                        <div class="clear author" v-if="item.speaker3"><span>{{item.speaker3}}</span><span>{{item.speaker3_job}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="action-wrap" style="display: none;">
                <div class=" sealer">
                    <div class="title">销售专员</div>
                    <div class="line"></div>
                    <div class="list">
                        <div class="time"><span v-html="sponsor.service_time"></span></div>
                        <div class="item" v-for="item in sponsor.sealer">
                            <div class="left avatar" :style="{backgroundImage: 'url('+util.autoImage(item.avatar)+')'}"></div>
                            <div class="left info">
                                <div class="middle">
                                    <div class="username">{{item.username}}</div>
                                    <div class="job">
                                        <p v-html="item.job"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="right link" v-if="user_info.id"><a :href="'mailto:'+item.email" @click="report(item)">联系我们</a></div>
                            <div class="right link" v-else><a href="javascript:;" @click="util.showAuth({show:true})">联系我们</a></div>
                        </div>
                    </div>
                </div>
                <div class=" qa" style="display:none">
                    <div class="title">赞助商问答</div>
                    <div class="line"></div>
                    <div class="box">
                        <div class="list" :class="user_info.id ? 'active' : ''" v-infinite-scroll="getSponsorQuestion"  infinite-scroll-distance="10">
                            <div class="item" v-for="item in question">
                                <div class="question"><i>{{item.user ? item.user.username : 'DELL用户'}}咨询：</i>{{item.question}}</div>
                                <div class="answer" v-if="item.answer"><i>官方回答：</i>{{item.answer?item.answer:"暂未回复"}}</div>
                            </div>
                            <div class="footer">{{footer == 1 ? "上拉加载更多" : footer == 2 ? "加载中" :"没有更多内容了"}}</div>
                        </div>
                        <div class="submit-box">
                            <div class="left input">
                                <input type="text" placeholder="请输入您想咨询的问题" v-model="key">
                            </div>
                            <div class="right btn" :class="[key ? '' : 'hidden']" @click="submit">发送</div>
                        </div>
                        <div class="tip" v-if="!user_info.id">登录后才可以提交问题，请先 <i @click="toLogin">登录</i></div>
                    </div>
                </div>
            </div>
        </div>
        <down-load :file="file_info" v-if="file_info.file_id" @hideDownload="hideDownload"></down-load>
        <video-float v-if="video_info.video" :video_info="video_info" @hideVideo="video_info = {}"></video-float>
    </main>
</template>

<script>
    import Crumbs from "../../../components/m/Crumbs";
    import DownLoad from "../../../components/m/DownLoad";
    import VideoFloat from "../../../components/m/VideoFloat";
    export default {
        name: 'detail',
        data() {
            return {
                query:"",
                video_play_show:true,
                tab:1,
                sponsor:{},
                question:[],
                key:"",
                footer:1,
                page:1,
                file_info:{},
                video_info:{},
                ids:[],
            }
        },
        components:{
            Crumbs,DownLoad,VideoFloat
        },
        computed:{
            user_info(){
                return this.$store.state.user_info
            },
            crumbs() {
				return {title:this.sponsor.type == 1 ? '我们的赞助商' : this.sponsor.type == 2 ? '特别鸣谢' : '其他赞助商',min_title:this.sponsor.crumbs_text ? this.sponsor.crumbs_text : this.sponsor.title}
            },
        },
        methods: {
            report(item){
                this.http.request({
                    api:"sponsor/contact",
                    data:{
                        sponsor_id:this.query.sponsor_id,
                        sealer_id:item.id
                    },
                    success:()=>{

                    }
                })
            },
            toMudu(item){
                if(!item.live_code){
                    return false;
                }
                var url = this.global.MUDU_HOST +item.live_code;
                if(this.$store.state.user_info.id){
                    var router = this.$router.resolve({
                        path:"/auth",
                        query:{
                            live_code:item.live_code,
                            redirect:url
                        }
                    });
                    window.open(router.href, '_blank');
                }else{
                    var from = "/auth?live_code="+item.live_code+"&redirect="+url
                    this.util.showAuth({
                        show:true,
                        from:from
                    });
                }
            },
            showDownload(item){
                if(this.$store.state.user_info.id){
                    this.file_info = item;
                }else{
                    this.util.showAuth({
                        show:true
                    })
                }
            },
            hideDownload(){
                this.file_info = {};
            },
            sendEmail(){
                this.$toast.success("已发送到您的邮箱");
            },
            setTab(tab){
                this.tab = tab;
                //this.stopVideo();
            },
            stopVideo(){
                var video = document.getElementById('s1_video');
                video.pause();
            },
			showVideo(item){
				this.video_info = {
					category_title:item.title,
					title:item.title,
					video:item.url
				}
			},
            playVideo(){
                this.video_info = this.sponsor;
            },
            getSponsorDetail(){
                this.http.request({
                    api:"sponsor/getSponsorDetail",
                    data:{
                        sponsor_id:this.query.sponsor_id
                    },
                    success:(res)=>{
                        this.sponsor = res.sponsor;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getSponsorQuestion(){
                if(this.footer != 1){return false;}
                this.footer = 2;
                this.http.request({
                    api:"sponsor/getSponsorQuestion",
                    data:{
                        sponsor_id:this.query.sponsor_id,
                        page:this.page,
                        ids:this.ids.join(',')
                    },
                    success:(res)=>{
                        this.question = this.question.concat(res.question);
                        if(res.question.length < res.limit){
                            this.footer = 3;
                        }else{
                            this.footer = 1;
                            this.page = this.page + 1;
                        }
                    }
                })
            },
            toLogin(){
                this.util.toLink('/login',{
                    from:this.$route.path == '/login' ? '/' : this.$route.fullPath
                })
            },
            submit(){
                if(!this.key){
                    return false;
                }
                if(!this.user_info.id){
                    this.util.showAuth({
                        show:true
                    });return  false;
                }
                this.http.request({
                    api:"sponsor/submitQuestion",
                    data:{
                        question:this.key,
                        sponsor_id:this.query.sponsor_id,
                    },
                    loading:true,
                    success:(res)=>{
                        this.ids.push(res.question_id);
                        this.question.push({
                            id:res.question_id,
                            question:this.key,
                            user:this.user_info
                        })
                        this.key = "";
                        this.$nextTick(()=>{
                            var element = document.querySelector(".qa .list");
                            element.scrollTop = element.scrollHeight;
                        })
                    }
                })
            },
            checkLogin(){
                if(!this.util.getAccessToken()){
                    this.util.showAuth({
                        show:true,
                        close_btn:true,
                    })
                }
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getSponsorDetail();
            this.getSponsorQuestion();
            this.checkLogin();
        },
        destroyed() {
            this.util.showAuth({
                show:false,
            })
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{padding-top: .25rem;background:#f6f6f6 url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;
        .about-wrap{
            .about{background: #fff;border-radius:.05rem;overflow: hidden;width: 7rem;margin: 0 auto;padding:.3rem 0;
                .logo{padding: .3rem;
                    .img{width: 4rem;height:1rem;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
                .tit{padding: 0 .25rem;font-size:.28rem;line-height: .3rem;margin-top: .3rem;}
                .desc{padding: 0 .25rem;margin-top:.1rem;font-size:.22rem;line-height: .36rem; color:#929292;white-space: pre-line}
                .link{width:2.3rem;height:.7rem;margin:.3rem auto 0;background: #1D56C0;text-align: center;line-height:.7rem;color:#fff;transition: all .3s ease;cursor: pointer;
                    span{padding-right: .2rem;background: url("~@/assets/image/58.png") no-repeat right center;background-size: .1rem;}
                }
            }
            .info{padding-bottom: .25rem;background: #fcfcfc;
                .info-tit{height:.9rem;margin: .25rem auto 0;background: #fff;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);text-align: center;
                    .center{display: inline-block;
                        .item{width: 2.3rem;height:.9rem; ;text-align: center;color:#565656;font-size: .24rem;transition: all .3s ease;cursor: pointer;
                            .middle{height:.9rem;width: 2.3rem;line-height: .34rem;}
                        }
                        .item.active{background: #1D56C0;color: #fff;transition: all .3s ease;position: relative}
                        .item.active::after{content: "";display: block;width: 100%;height: .1rem;position: absolute;left:0;bottom:0;background: #63b4e1;}
                    }
                }
                .video-box{width: 7rem; height:3.9rem;position: relative;margin:.25rem auto 0;overflow: hidden;display: none;border-radius: .05rem;
                    video{height:3.9rem;display: block;object-fit: cover;}
                    video.full{position: fixed;left:0;top:0;width: 100%;height:100%; z-index: 1000;object-fit: contain;background: #000;}
                    .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.5);
                        .play{width: 1rem;height:1rem;position: absolute;top:50%;left:50%;background: url("~@/assets/image/4.png") no-repeat left center;background-size: contain;margin-left: -.5rem;margin-top: -.5rem; cursor: pointer;}
                    }
                    .full-close{width: .8rem;height:.8rem;position: fixed;top:0;right:0;background: url("~@/assets/image/m3.png") no-repeat center center;background-size: .29rem;z-index: 1001;display: none;}
                }
                .video.full{
                    .full-close{display: block;}
                }
                .video-box.active{display: block;}
                .download-box{height:4rem;position: relative;margin-top:.2rem;border-radius:.05rem;overflow: hidden;display: none;
                    .list{height:4rem;width: 6.9rem;margin: 0 auto;padding-right: .1rem; overflow: hidden;overflow-y: auto;
                        .item{padding:.3rem 0;border-bottom:.02rem solid #d7d7d7;overflow: hidden;
                            .tit-box{padding-left:.8rem;width:4.5rem;
                                .middle{height:.6rem;
                                    .tit{font-size: .26rem;}
                                    .m-tit{font-size:.22rem;color:#565656;width:3.6rem;}
                                }
                            }
                            .tit-box.word{background: url("~@/assets/image/25_1.png") no-repeat left center;background-size: contain;}
                            .tit-box.pdf{background: url("~@/assets/image/23.png") no-repeat left center;background-size: contain;}
                            .tit-box.ppt{background: url("~@/assets/image/24.png") no-repeat left center;background-size: contain;}
                            .tit-box.video{background: url("~@/assets/image/90.png") no-repeat left center;background-size: contain;}
                            .size{text-align: center;line-height:.6rem;font-size:.2rem;margin-left: .2rem;display: none;}
                            .link{line-height:.6rem;font-size:.24rem;padding-left:.3rem;background: url("~@/assets/image/25.png") no-repeat left center;background-size:.18rem;margin-left:.1rem;float: right;
                                a{color:#0176ce;}
                            }
							.link.video{background-image: url("~@/assets/image/91.png");background-size:.26rem;padding-left: .36rem;}
                        }
                        .item:nth-last-child(1){border-bottom: none;}
                    }
                    .list::-webkit-scrollbar{width:.06rem;background-color: #e1e2e2;border-radius:.03rem;}
                    .list::-webkit-scrollbar-thumb{background-color: #0176ce;border-radius:.03rem;}
                }
                .download-box.active{display: block;}
                .plan-box{height:4rem;position: relative;margin-top: .2rem;border-radius:.05rem;overflow: hidden;display: none;
                    .list{height:4rem;width: 6.9rem;margin: 0 auto;padding-right: .1rem; overflow: hidden;overflow-y: auto;
                        .item{padding:.3rem 0;border-bottom:.02rem solid #d7d7d7;overflow: hidden;font-size: .24rem;
                            .time{width: 1.7rem;color:#194478;text-align: center;line-height: .36rem;}
                            .tit-box{width: 5rem;line-height: .36rem;
                                .tit{font-weight: bold;}
                                .author{color:#565656;font-size: .22rem;
                                    span{display: block;float: left;}
                                    span:nth-child(1){max-width:.74rem;}
                                    span:nth-child(2){width: 4.1rem;margin-left:.1rem;}
                                }
                            }
                        }
                        .item:nth-last-child(1){border-bottom: none;}
                    }
                    .list::-webkit-scrollbar{width:.06rem;background-color: #e1e2e2;border-radius:.03rem;}
                    .list::-webkit-scrollbar-thumb{background-color: #0176ce;border-radius:.03rem;}
                }
                .plan-box.active{display: block;}
            }
        }
        .action-wrap{background: #f1f1f1;
            .sealer{padding-top: .4rem;
                .title{font-size:.32rem;text-align: center}
                .line{width:1.4rem;height:.04rem;margin:.1rem auto 0; background: #3176c8;}
                .list{padding:0 .25rem .5rem;width: 6.5rem;margin: .25rem auto 0; background: #fff;
                    .time{font-size:.25rem;color:#0176ce;padding: .2rem 0; line-height: .3rem;text-align: center;
                        span{padding-left:.35rem;background: url("~@/assets/image/56.png") no-repeat left center;background-size:.3rem;}
                    }
                    .item{overflow: hidden;margin:.25rem 0 .5rem; cursor: pointer;
                        .avatar{width:1.5rem;height:1.5rem;background-repeat: no-repeat;background-position: center center;background-size:cover;border-radius: 50%;background-image: url("~@/assets/image/5.png");}
                        .info{width:2.8rem;margin-left:.2rem;
                            .middle{height:1.5rem;
                                .username{font-size:.28rem;}
                                .job{font-size:.22rem;line-height:.32rem;color: #565656;white-space: pre-line; }
                            }
                        }
                        .link{width:1.5rem;height:.6rem;background: #0176ce; text-align: center;line-height: .6rem;font-size:.24rem;color:#0176ce;transition: all .3s ease;margin-top:.45rem;
                            a{color:#fff}
                        }
                    }
                    .item:nth-last-child(1){margin-bottom: 0;}
                }
            }
            .qa{padding-top: .4rem;padding-bottom: .4rem;
                .title{font-size:.32rem;text-align: center}
                .line{width:1.4rem;height:.04rem;margin:.1rem auto 0; background: #3176c8;}
                .box{background: #fff;padding:.2rem .2rem .5rem;width: 6.6rem;margin: .25rem auto 0;
                    .list{height:6.5rem;overflow: hidden;overflow-y: auto;
                        .item{margin-bottom:.2rem;
                            .question{padding:.2rem;background: #f6f6f6;font-size:.22rem;color:#565656;line-height:.36rem;
                                i{font-weight: bold;}
                            }
                            .answer{padding:.2rem;background: #fff;font-size:.22rem;color:#565656;line-height: .36rem;
                                i{font-weight: bold;}
                            }
                        }
                        .footer{height:.5rem;line-height:.5rem;text-align: center;font-size: .24rem;color:#999;display: none;}
                    }
                    .list::-webkit-scrollbar{width:.06rem;background-color: #e1e2e2;border-radius:.03rem;}
                    .list::-webkit-scrollbar-thumb{background-color: #0176ce;border-radius:.03rem;}
                    .submit-box{margin-top:.5rem;overflow: hidden;border:.02rem solid #3176c8;border-radius:.05rem;position: relative;
                        .input{height:.7rem;
                            input{padding:0 .2rem;width:4.8rem;line-height:.7rem;font-size:.24rem;border: none;}
                        }
                        .btn{position: absolute;top:0;right:0; width: 1.4rem;height:.7rem;line-height: .7rem;text-align:center;background: #3176c8;color:#fff;cursor: pointer;}
                        //.btn.hidden{background: #999;}
                    }
                    .tip{height:.4rem;line-height: .4rem;color:red;font-size: .24rem;display: none;
                        i{color:#3176c8;cursor: pointer;}
                    }
                }
            }
        }
    }
</style>

